export const API_CONSTANTS = {
    AUTH: '/auth',
    LOGIN: '/login',
    REGISTER: '/register',
    DEVICE: '/devices',
    END_USERS: '/end-users',
    END_USERS_V2: '/end-users-v2',
    CHECK_IN: '/check-in',
    VERIFY_CODE: '/verify-mfa-code',
    RESEND_CODE: '/resend-mfa-code',
    FORGOT_PASSWORD: '/forget-password',
    SET_PASSWORD: '/set-password',
    CHANGE_PASSWORD: '/change-password',
    LINK_DEVICE: '/link-device',
    UNLINK_DEVICE: '/unlink-device',
    ORGANIZATIONS: '/organizations',
    CONFIGURATIONS: '/configurations',
    ADMINS: '/admins',
    ROLES: '/roles',
    ACTIVITY_LOGS: '/activity-logs',
    ADVOCATES: '/advocates',
    SELF: '/self',
    LOOKUP: '/lookups',
    REFRESH: '/refresh',
    LOGOUT: '/logout',
    NOTIFICATION: '/notification',
    ACTIVITIES: '/activities',
    NOTES: '/notes',
    MIGRATION: '/migration',
    UPDATE_COLUMN: '/update-column',
    WATCH_THEMES: '/watch-themes',
    THREAT_PAIRS: '/threat-pairs',
    THREAT_PAIR_LOCATIONS: '/threat-pair-locations',
    /**
     * Placeholder path for the Monitored Subject's (perpetrator's) GPS feed (NEX-1534) — no
     * backend endpoint exists for this yet. Requests to `/end-users/{id}/perpetrator-locations`
     * are served by `PerpetratorLocationsMockInterceptor`, never a real server, so the calling
     * code already looks exactly like it will once a real endpoint lands: just delete the
     * interceptor (and its registration in app.module.ts) at that point, no call-site changes.
     */
    PERPETRATOR_LOCATIONS: '/perpetrator-locations',
};